import { defineStore } from 'pinia'
import { DialOptions } from '@/legacy/types/entities/phoneNumbers'

/**
 * Holds state for the "restricted number" dial-confirmation flow.
 *
 * When a user tries to dial a restricted number, `dial()` stashes the pending
 * call details here and opens the warning modal instead of dialing. The modal
 * reads `pendingDial` to either proceed with the call ("Call anyway") or
 * dismiss ("Email instead").
 * @module
 */
export const useRestrictedDialStore = defineStore('restrictedDial', {
  state: () => ({
    isModalOpen: false,
    pendingDial: null as DialOptions | null,
  }),
  actions: {
    /**
     * Stash the attempted call and open the warning modal.
     * @param options the dial options the user attempted
     */
    requestConfirmation(options: DialOptions) {
      this.pendingDial = options
      this.isModalOpen = true
    },
    /**
     * Close the modal and clear the pending call.
     */
    close() {
      this.isModalOpen = false
      this.pendingDial = null
    },
  },
})
